import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useI18n } from '@/context/LanguageContext';
import { Separator } from '@/components/ui/separator';

// Shared renderer for legal pages. `base` is a dot-path into the dictionary,
// e.g. 'legal.privacy'. Content (title/updated/intro/sections) comes from i18n.
export function LegalPage({ base }) {
  const { t, lang } = useI18n();
  const { lang: routeLang } = useParams();
  const l = routeLang || lang;
  const data = t(base);
  const sections = Array.isArray(data.sections) ? data.sections : [];

  return (
    <div className="bg-background">
      <div className="mx-auto max-w-[820px] px-4 py-14 sm:px-6 lg:py-20 lg:px-8">
        <Link
          to={`/${l}`}
          className="inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-wide text-muted-foreground transition-colors hover:text-[hsl(var(--inv-blue))]"
          data-testid="legal-back-home-link"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          {t('legal.backHome')}
        </Link>

        <h1 className="mt-6 font-heading text-3xl font-semibold tracking-tight text-[hsl(var(--inv-slate))] sm:text-4xl">
          {data.title}
        </h1>
        <p className="mt-2 font-mono text-xs text-muted-foreground">
          {t('legal.updatedLabel')}: {data.updated}
        </p>

        <Separator className="my-7" />

        <p className="text-[15px] leading-relaxed text-muted-foreground">{data.intro}</p>

        <div className="mt-8 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading text-lg font-semibold text-[hsl(var(--inv-slate))]">{s.h}</h2>
              <div className="mt-3 space-y-3">
                {Array.isArray(s.p) &&
                  s.p.map((para, pi) => (
                    <p key={pi} className="text-[15px] leading-relaxed text-muted-foreground">{para}</p>
                  ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LegalPage;
